import { api } from "src/boot/api";
export const index = async (options = {}) => {
  const response = await api.get(`kam/ledgers`, options);

  return response;
};

export const getUsers = async (options = {}) => {
  const response = await api.get("/kam/ledgers/users", options);

  return response;
};
export const getPastLedgerUser = async (options = {}) => {
  const response = await api.get(
    "/kam/past-generated-ledgers/parties",
    options,
  );

  return response;
};

export const getUserStates = async (options = {}) => {
  const response = await api.get(`/kam/ledgers/user/state`, options);

  return response;
};

export const getAddressByStates = async (options = {}) => {
  const response = await api.get(`/kam/ledgers/addresses`, options);

  return response;
};

export const getPartyVouchers = async (options = {}) => {
  const { partyType } = options;
  const response = await api.get(`/kam/ledgers/voucher/${partyType}`, options);

  return response;
};

export const getPastGeneratedLedgers = async (options = {}) => {
  const response = await api.get(`/kam/past-generated-ledgers`, options);

  return response;
};

export const postExportLedger = async (payload, options = {}) => {
  const response = await api.post(`/kam/ledgers/export`, payload, options);

  return response;
};

export const postShareLedger = async (payload, options = {}) => {
  const response = await api.post(`/kam/ledgers/share`, payload, options);

  return response;
};

export const postPastGeneratedLedgers = async (payload, options = {}) => {
  const response = await api.post(
    `/kam/past-generated-ledgers`,
    payload,
    options,
  );

  return response;
};

export const getLedgerStatus = async (id, options = {}) => {
  const response = await api.get(`/kam/ledgers/status/${id}`, options);

  return response;
};

export const getSharedLedgers = async (options = {}) => {
  const response = await api.get(`/shared/ledgers`, options);

  return response;
};

export const postSharedExportLedgers = async (options = {}) => {
  const response = await api.post(`/shared/ledgers/export`, options);

  return response;
};
export const getSharedLedgersStatus = async (id, options = {}) => {
  const response = await api.get(`/shared/ledgers/status/${id}`, options);

  return response;
};
export const getBusinessChannel = async (options = {}) => {
  const response = await api.get(
    `/kam/users/business-channels/ledgers`,
    options,
  );

  return response;
};
export const getLedgerContacts = async (options = {}) => {
  const response = await api.get("/kam/ledger/contacts", options);

  return response;
};
export const getLedgerByLinkId = async (linkId, options = {}) => {
  const response = await api.get(
    `/shared/past-generated-ledgers/${linkId}`,
    options,
  );

  return response;
};

export const putPastGeneratedLedgerStatus = async (payload, options = {}) => {
  const response = await api.put(
    "/kam/past-generated-ledgers/status",
    payload,
    options,
  );

  return response;
};
